import {
	submitEvent,
	submitEventMerge,
	submitMerge,
	submitMove,
	trackOnNextPageImpression
} from "@otto-ec/tracking-bct";

export default class TrackingService {
	getComboButtonWidgetPayload(comboId, source, status, comboType) {
		const comboButtonWidgetPayload = {
			id: "ft3bcn_cobu1",
			name: "ComboButton",
			position: 1,
			status: status,
			labels: {
				promo_FeatureNumber: ["1"],
				promo_FilledSlots: ["1"],
				promo_Feature: ["true"],
				promo_Content: [comboId],
				promo_Source: [source],
				promo_ComboType: [comboType]
			}
		};
		return comboButtonWidgetPayload;
	}

	getComboButtonPayload(status, variationId) {
		return {
			id: "ft3bcn_cobu1_tile1",
			parentId: "ft3bcn_cobu1",
			name: "ComboButton-Tile",
			position: 1,
			status: status,
			variationId: variationId,
			labels: {}
		};
	}

	sendPromoButtonClickTrackingEvent(comboId, comboSource, comboType, variationId) {
		const statusName = "click";
		const status = "clicked";

		const legacyTrackingEventPayload = {
			"wk.promo_AttributionFeature": this.buildAttributionFeature(comboType),
			promo_ComboType: comboType,
			"wk.promo_AttributionSource": comboSource
		};
		const featureTrackingEventPayload = {
			name: statusName,
			features: [
				this.getComboButtonWidgetPayload(comboId, comboSource, status, comboType),
				this.getComboButtonPayload(status, variationId)
			]
		};
		submitMove(legacyTrackingEventPayload, featureTrackingEventPayload);
		trackOnNextPageImpression({ promo_Click: "ComboButton" });
	}

	sendPromoButtonOpenTrackingEvent(comboId, comboSource, comboType, variationId) {
		const action = "open";
		const status = "clicked";

		const baseTrackingEventPayload = {
			promo_ComboType: comboType,
			ot_MessageType: "event"
		};
		const featureTrackingEventPayload = {
			name: action,
			features: [
				this.getComboButtonWidgetPayload(comboId, comboSource, status, comboType),
				this.getComboButtonPayload(status, variationId)
			]
		};

		submitEvent(baseTrackingEventPayload, featureTrackingEventPayload);
	}

	buildAttributionFeature(comboType) {
		const comboTypeCase = comboType[0].toUpperCase() + comboType.substring(1).toLowerCase();
		const pageCluster = window.o_util.misc.getPagecluster();
		return `ComboButton${comboTypeCase}_${pageCluster}`;
	}

	sendPromoButtonPageImpressionTrackingEvent(comboId, comboSource, comboType, variationId) {
		const loadEventPayload = this.createLoadEventPayload(comboId, comboSource, comboType, variationId);

		submitMerge({}, loadEventPayload);
	}

	sendPromoButtonMergePageImpression(comboId, comboSource, comboType, emid, variationId) {
		const payload = {
			name: "change",
			features: this.createLoadEventPayload(comboId, comboSource, comboType, variationId)
		};

		submitEventMerge(emid, {}, payload);
	}

	createLoadEventPayload(comboId, comboSource, comboType, variationId) {
		const status = "loaded";
		return [
			this.getComboButtonWidgetPayload(comboId, comboSource, status, comboType),
			this.getComboButtonPayload(status, variationId)
		];
	}
}
